module.exports = "/fonts/Flaticon2.woff?b242ac810bd8cccaa03abc2128b7c3c3";